import React, { useCallback, useEffect } from "react";
import { makeStyles, Button, Drawer, ButtonBase, Typography } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Clear";

import FilterMobile from "./FilterMobile";
import useFilters from "hooks/useFilters";
import { gtmPush } from "lib/gtm";

export default function FiltersMobilePanel({ open, onClose, filters, category, filterComponent, onReset }) {
  const classes = useStyle();
  const [, dispatch] = useFilters();
  const reset = useCallback(() => {
    dispatch({ type: "reset" });
  }, [dispatch]);
  const subcategory2Filter = [];
  if (category?.subcategories2 && category.subcategories2.length > 0) {
    subcategory2Filter.push({
      id: "subcategory2",
      name: "Sous catégorie",
      type: "options",
      values: category.subcategories2,
    });
  }

  useEffect(() => {
    if (open) {
      gtmPush({ event: "FiltersMobilePanel-Open" });
    }
    if (!open) {
      gtmPush({ event: "FiltersMobilePanel-Close" });
    }
  }, [open]);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      transitionDuration={400}
      onClose={() => onClose()}
      className={classes.drawer}
      keepMounted
    >
      <div className={classes.header}>
        <Typography variant="h3" className={classes.title}>
          Filtrer
        </Typography>
        <ButtonBase disableRipple onClick={onClose}>
          <CancelIcon className={classes.closeIcon} />
        </ButtonBase>
      </div>
      {filterComponent ? (
        <div className={classes.filtersContainer}>{filterComponent}</div>
      ) : (
        <div className={classes.filtersContainer}>
          :
          {[...filters, ...subcategory2Filter].map((filter) => (
            <FilterMobile key={filter.id} filter={filter} category={category} />
          ))}
        </div>
      )}
      <div className={classes.bottomActions}>
        <ButtonBase
          className={classes.reinit}
          onClick={() => {
            onClose();
            onReset ? onReset() : reset();
          }}
        >
          Réinitialiser
        </ButtonBase>
        <Button variant="contained" onClick={onClose} color="primary" className={classes.buttonConfirm}>
          Appliquer
        </Button>
      </div>
    </Drawer>
  );
}

const useStyle = makeStyles((theme) => ({
  reinit: {
    fontWeight: 500,
    boxShadow: "none",
    color: theme.palette.text.disabled,
  },
  buttonConfirm: {
    flex: 1,
    marginLeft: theme.spacing(6),
  },
  bottomActions: {
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "fixed",
    bottom: 0,
    backgroundColor: "white",
    borderTop: "1px solid #D7D7D7",
    padding: theme.spacing(2),
    width: "100vw",
    marginLeft: -theme.spacing(2),
    height: 70,
  },
  filtersContainer: {
    marginBottom: 170,
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  closeIcon: {
    fontSize: 30,
    color: theme.palette.secondary.main,
  },
  title: {
    color: theme.palette.secondary.main,
  },
  drawer: {
    "& .MuiPaper-root": {
      height: "100%",
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      overflowX: "hidden",
      paddingTop: theme.spacing(5),
    },
  },
}));
